import script from "./process-control.vue?vue&type=script&lang=ts&setup=true"
export * from "./process-control.vue?vue&type=script&lang=ts&setup=true"

import "./process-control.vue?vue&type=style&index=0&id=01a28104&lang=scss"

const __exports__ = script;

export default __exports__